import { apiClient } from '@/core/api/client';
import { Endpoints } from '@/core/api/endpoints';
import type { RegisterRequest, RegisterResponse } from '../types';

class RegistrationService {
    async register(request: RegisterRequest): Promise<RegisterResponse> {
        return await apiClient.post<RegisterResponse, RegisterRequest>(
            Endpoints.registration.register,
            request
        );
    }
}

export const registrationService = new RegistrationService();

